/**
 * Created by qinghua.gong on 2019/4/9.
 */
import Axios from 'axios'
import router from '@/router/index'
import Cookies from 'js-cookie'
// import {stringify} from 'qs'

const globalConfig = {
    headers: {
        post: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        get: {
            'Content-Type': 'application/x-www-form-urlencoded',
            "Accept": "application/json"
        }
    },
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    timeout: 30000
}
Object.assign(Axios.defaults, globalConfig)
Axios.interceptors.request.use(config => {
    return config
}, error => Promise.reject(error))
Axios.interceptors.response.use(res => res, handleAllException)

function handleAllException (err) {
    err.success = false
    err.status = 0
    err.message = err.message || 'Service Exceptions'

    if (err.response) {
        let res = err.response
        err.message = res.message
        if (res.data && res.data.message) {
            err.message = res.data.message
        }
        err.status = err.response.status
    }

    if (err && (err.status == 401 || err.status == 302)) {
        showLogin();
    }

    if (err && error.message.includes('timeout')) {
        err.status = 100;
    }

    return Promise.reject(err)
}

function showLogin () {
    router.push('/login')
}

function getCancelToken (data = {}) {
    var cancelToken = data.cancelToken
    if (data.cancelToken) {
        delete data.cancelToken
    }
    return cancelToken ? cancelToken.token : null
}

function getLoginToken(){
  return Cookies.get('admin_token');
}

function getCustomeHeader () {
    return {
        version: '1.0.0',
        countryCode: 'GH',
        lang: 'en',
        token: getLoginToken(),
    }
}
function getErrorMessage(res) {
    if (res.data && res.data.error && (res.data.error.code == 911)) {
        return true
    } else {
        return false
    }
}

function getResponseData (res) {
    res.noLogin = getErrorMessage(res);
    if (res && res.noLogin == true) {
        showLogin();
    }
    return res.data
}
function getResponseBlobData (res) {
    return res.data
}
function catchResponse (res) {
    if (res.error && res.error.code == '10005') {
        showLogin();
    }
    return res;
}
function extractData (res) {
    return res.data;
}
export default {
    post (url, data = {}, options = {}) {
        return Axios({
            method: 'post',
            url,
            data: data || {},
            headers: getCustomeHeader(),
            cancelToken: getCancelToken(options)
        }).then(getResponseData).catch(catchResponse)
    },
    get (url, params = {}, options = {}) {
        return Axios({
            method: 'get',
            url,
            params: params || {},
            headers: getCustomeHeader(),
            cancelToken: getCancelToken(options)
        }).then(getResponseData).catch(catchResponse)
    },
    postFormData (url, data = {}, options = {}) {
        return Axios({
            method: 'post',
            url,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: JSON.stringify(data),
            cancelToken: getCancelToken(options)
        }).then(getResponseData)
    },
    getBlog (url, params = {}, options = {}) {
        return Axios({
            method: 'get',
            url,
            params: params || {},
            headers: getCustomeHeader(),
            cancelToken: getCancelToken(options),
            responseType: 'blob',
        }).then(getResponseBlobData);
    },
}



// WEBPACK FOOTER //
// ./src/api/request.js